<template>
    <section class="team-mob"  v-if="loaded && ready" style="padding-bottom: 0!important; padding-top: 0!important; margin-top: 0!important;">


      <div class="container" :class="{'vis' :  offSet.last >= offsetIndex}"    >



        <div class="list-people  list-people-partners">
          <transition-group name="fade" >




            <div class="item-people-block" v-for="(item, index) in partData" :key="index" >
              <div class="item-people"v-on:click="openPeople(index)">
                <img :src="item.img" :alt="item.name">
                <div class="partner-name">
                  <p>
                    <strong>{{item.name}}</strong>
                    <span>{{item.func[lang].name}}</span>
                  </p>

                </div>

              </div>
              <div class="text-people"  :class="{'vis' : activePeople === index}" >
                <div  class="text-people-content">


                  <div class="text-people-quote">{{item.quote}}</div>
                  <div class="text-people-text" v-html="item.text[lang].name"> </div>

                </div>
              </div>
            </div>









          </transition-group>
          <transition name="fade">
          <div class="load-more" v-on:click="loadMore();" v-if="pairVis < teamDataPair.length">

            ver mais pessoas <span>+</span>
          </div>
          </transition>
        </div>







        </div>




      <!--div  v-if="itemActive != 99" class="ball-text-aux">{{newArr[itemActive].text[lang].name}}</div-->
    </section>
</template>

<script>




    import {TweenMax} from "gsap/TweenMax";
    import {EVENTBUS, PROJ, WP} from '../../main';
    import MediaType from "./MediaType";




   // import Masonry from "masonry-layout/masonry";



    export default {


        name: 'partners-mob',
      components: { MediaType},
      props: ['actRoute', 'offSet', 'lang', 'isMobile' , 'offsetIndex', 'partners'],
        data() {
            return {
              loaded: false,
              ready: false,
              teamData: [],
              partData: [],

              teamDataPair: [],
              activePeople: 999,
              pairVis: 2


            }
        },

      created() {
        const _this = this;

        //alert(this.$route.path.substring(9, this.$route.path.length))

        WP('team', function (response){





          _this.loaded = true;
          let tmp = [];


          for(let i = 0; i < response.length; i++){

            console.log(response[i].partner)


            if(_this.partners) {

              if(response[i].partner){
                tmp.push(response[i])
              }

            }

          }

          _this.partData =  tmp;

          let count = 0;
          let inc = 0;




          _this.init();

        });

      },
      mounted() {
        const _this = this;
        _this.ready = true;
        _this.init();



      },

      destroyed() {

      },

      methods: {





        init() {
          const _this = this;

          if(this.loaded && this.ready){



          }
        },


        getShuffledArr (arr){
          return [...arr].map( (_, i, arrCopy) => {
            var rand = i + ( Math.floor( Math.random() * (arrCopy.length - i) ) );
            [arrCopy[rand], arrCopy[i]] = [arrCopy[i], arrCopy[rand]]
            return arrCopy[i]
          })
        },

        openPeople(n){
          this.activePeople = n;


        },

        loadMore(){
          this.pairVis ++;
        }

























        },
    };

</script>


// WEBPACK FOOTER //
// src/components/Modules/PartnersMob.vue